import { render, staticRenderFns } from "./AddNewDnsRecordModal.vue?vue&type=template&id=76a54752&"
import script from "./AddNewDnsRecordModal.vue?vue&type=script&lang=js&"
export * from "./AddNewDnsRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports